import React, { Component } from 'react';
import { message } from 'antd';
import { withAsyncActions } from 'react-async-client';

import CompanyForm from '../forms/CompanyForm';
import { postCompany, putCompany } from '../../actions/asyncActions';
import Modal from './Modal';

class CompanyModal extends Component {
    render() {
        const { modal, postCompany, putCompany, params } = this.props;

        return <Modal
            {...modal}
            title={params ? 'Редактировать компанию' : 'Добавить компанию'}
            footer={null}>
            <CompanyForm
                formAction={params ? putCompany : postCompany}
                item={params} />
        </Modal>
    }
}

export default withAsyncActions({
    postCompany: postCompany
        .withSuccessHandler(({ close }) => {
            message.success('Компания успешно добавлена');
            close();
        })
        .withOptions({ resetOnUnmount: true }),
    putCompany: putCompany
        .withSuccessHandler(({ close }) => {
            message.success('Компания успешно изменена');
            close();
        })
        .withOptions({ resetOnUnmount: true })
})(CompanyModal);
